import React, { useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import { Autoplay, FreeMode, Navigation } from 'swiper/modules'
import { useTranslation } from 'react-i18next'
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from 'react-icons/md'

interface SwiperCardsProps {
    children: React.ReactNode;
    currentPage?: number;
    lastPage?: number;
    onLoadMore?: () => void;
}
const SwiperCards = ({ children, currentPage, lastPage, onLoadMore }: SwiperCardsProps) => {
    const { i18n } = useTranslation()
    const childrenArray = React.Children.toArray(children)
    const prevRef = useRef(null)
    const nextRef = useRef(null)
    return (
        <div className=' relative xs:ps-6 lg:ps-10 '>
            <div className={`absolute -top-[70px]  flex gap-2 z-10 ${i18n.language === "ar" ? "left-5" : "right-5"}`}>
                <button ref={prevRef} className="bg-white text-secondry border border-secondry shadow-md xs:p-1 sm:p-2 rounded-full transition-all hover:bg-secondry hover:text-white">
                    {i18n.language === "ar" ? <MdKeyboardArrowRight /> : <MdKeyboardArrowLeft />}
                </button>
                <button ref={nextRef} className="bg-secondry text-white shadow-md xs:p-1 sm:p-2 rounded-full">
                    {i18n.language === "ar" ? <MdKeyboardArrowLeft /> : <MdKeyboardArrowRight />}
                </button>
            </div>
            <Swiper
                slidesPerView={3}
                spaceBetween={20}
                freeMode={true}
                navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                }}
                onBeforeInit={(swiper: any) => {
                    if (swiper.params.navigation && typeof swiper.params.navigation !== 'boolean') {
                        swiper.params.navigation.prevEl = prevRef.current
                        swiper.params.navigation.nextEl = nextRef.current
                    }
                }}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                modules={[FreeMode, Navigation, Autoplay]}
                className="mySwiper"
                breakpoints={{
                    320: { slidesPerView: 1.2 },
                    640: { slidesPerView: 2.5 },
                    1024: { slidesPerView: 4.5 },
                    1280: { slidesPerView: 5.5 },
                }}
                onReachEnd={() => {
                    if (onLoadMore && currentPage && lastPage && currentPage < lastPage) {
                        onLoadMore();
                    }
                }}
            >
                {childrenArray.map((child, index) => (
                    <SwiperSlide key={index}>{child}</SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default SwiperCards
